import { render } from "./PoCModalView.vue?vue&type=template&id=b90bce4e"
import script from "./PoCModalView.vue?vue&type=script&lang=js"
export * from "./PoCModalView.vue?vue&type=script&lang=js"

import exportComponent from "/gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__